import { useQuery as useProductPromotionsQuery } from "@faire/web-api--source/endpoints/www/api/product/productToken/product-promo-messages/get-hooks";

import { getProductPromotionState } from "./getProductPromotionState";
import { IProductPromotionsData } from "./interfaces";

export const PRODUCT_PROMOTIONS_STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const useProductPromotionsState = (
  productToken: string | undefined
): IProductPromotionsData => {
  const { data: productPromotions } = useProductPromotionsQuery(
    productToken ?? "",
    {
      refetchOnMount: false,
      enabled: !!productToken,
      staleTime: PRODUCT_PROMOTIONS_STALE_TIME,
    }
  );
  return getProductPromotionState(productPromotions);
};
